// extracted by mini-css-extract-plugin
module.exports = {"item":"list_item__xh7_7","count":"list_count__RbHzM","count_primary":"list_count_primary___5Goe","count_secondary":"list_count_secondary__KqLnx"};